import type { DrillType } from "@-/dev.improve.haniverse.lib.drill.entities";
import {
  studyEnvironmentStudyMode,
  type StudyEnvironment,
} from "@-/dev.improve.haniverse.lib.learn.study-environment";
import type {
  LearnSummaryContinueDestination,
  LearnSummaryPageResolution,
} from "#learn-summary-page-resolution";

/** The card the summary's Start opens: the head of the content-validated study queue. */
export type LearnSummaryQueueHead =
  | {
      drillType: DrillType;
      grapheme: string;
      kind: "review";
      /** Hands-Free opens the review by voice. */
      studyMode: "manual" | "voice";
    }
  | { kind: "quiz"; quizSlug: string; source: "review" }
  | LearnSummaryContinueDestination;

/**
 * The surfaced review when there is one, otherwise the next lesson; `null` when there is nothing
 * to study. Read from a content-validated resolution (`validateContent: true`): only that one can
 * name a review.
 */
export function learnSummaryQueueHead(
  resolution: LearnSummaryPageResolution,
  studyEnvironment: StudyEnvironment,
): LearnSummaryQueueHead | null {
  const { reviewDrill } = resolution;
  if (reviewDrill !== null) {
    return reviewDrill.kind === "quiz"
      ? { kind: "quiz", quizSlug: reviewDrill.quizSlug, source: "review" }
      : {
          drillType: reviewDrill.drillType,
          grapheme: reviewDrill.grapheme,
          kind: "review",
          studyMode: studyEnvironmentStudyMode(studyEnvironment),
        };
  }
  return resolution.continueDestination;
}
